import React from 'react';
import { Check, X, Plus } from 'lucide-react';

const CategoryStep = ({ formData, updateField, addSubject, removeSubject, categories, popularSubjects }) => (
    <div className="space-y-6 animate-in fade-in slide-in-from-right-4 duration-300">
        <div>
            <label className="block text-sm font-semibold text-gray-700 mb-3">What type of learning?</label>
            <div className="grid grid-cols-2 gap-3">
                {categories.map(cat => (
                    <button
                        key={cat.value}
                        onClick={() => updateField('category', cat.value)}
                        className={`relative p-4 rounded-2xl border-2 text-left transition-all duration-200 hover:shadow-md ${formData.category === cat.value
                            ? 'border-[#041f96] bg-[#041f96]/5 shadow-md shadow-blue-100'
                            : 'border-gray-200 hover:border-gray-300'
                            }`}
                    >
                        {formData.category === cat.value && (
                            <div className="absolute top-2 right-2 w-5 h-5 rounded-full bg-[#041f96] flex items-center justify-center">
                                <Check className="h-3 w-3 text-white" />
                            </div>
                        )}
                        {React.createElement(cat.icon, { className: "h-6 w-6 mb-2 text-[#041f96]" })}
                        <p className="font-semibold text-gray-900 text-sm">{cat.label}</p>
                        <p className="text-xs text-gray-500 mt-0.5">{cat.description}</p>
                    </button>
                ))}
            </div>
        </div>

        <div>
            <label className="block text-sm font-semibold text-gray-700 mb-3">
                Which subjects? <span className="text-gray-400 font-normal">({formData.subjects.length} selected)</span>
            </label>

            {/* Selected chips */}
            {formData.subjects.length > 0 && (
                <div className="flex flex-wrap gap-2 mb-3">
                    {formData.subjects.map(s => (
                        <span key={s} className="inline-flex items-center gap-1 px-3 py-1.5 bg-[#041f96] text-white text-sm rounded-full font-medium">
                            {s}
                            <button onClick={() => removeSubject(s)} className="ml-1 hover:bg-white/20 rounded-full p-0.5">
                                <X className="h-3 w-3" />
                            </button>
                        </span>
                    ))}
                </div>
            )}

            {/* Custom input */}
            <div className="flex gap-2 mb-3">
                <input
                    type="text"
                    value={formData.subjectInput}
                    onChange={(e) => updateField('subjectInput', e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' && formData.subjectInput.trim()) {
                            e.preventDefault();
                            addSubject(formData.subjectInput.trim());
                        }
                    }}
                    placeholder="Type a subject..."
                    className="flex-1 px-4 py-2.5 border-2 border-gray-200 rounded-xl text-sm focus:border-[#041f96] focus:outline-none transition-colors"
                />
                <button
                    type="button"
                    onClick={() => {
                        if (formData.subjectInput.trim()) {
                            addSubject(formData.subjectInput.trim());
                        }
                    }}
                    disabled={!formData.subjectInput.trim()}
                    className="flex items-center justify-center w-11 h-11 rounded-xl bg-[#041f96] text-white hover:bg-[#031580] disabled:opacity-40 disabled:cursor-not-allowed transition-all shrink-0"
                    title="Add subject"
                >
                    <Plus className="h-5 w-5" />
                </button>
            </div>

            {/* Popular subjects */}
            <div className="flex flex-wrap gap-2">
                {popularSubjects.filter(s => !formData.subjects.includes(s)).map(s => (
                    <button
                        key={s}
                        onClick={() => addSubject(s)}
                        className="px-3 py-1.5 text-sm border border-gray-200 rounded-full text-gray-600 hover:border-[#041f96] hover:text-[#041f96] hover:bg-[#041f96]/5 transition-all"
                    >
                        + {s}
                    </button>
                ))}
            </div>
        </div>
    </div>
);

export default CategoryStep;
